import "./offered-plans-carousel.scss"
import { Swiper } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
// TODO: seems like deprecated, there is a SCSS way to import those
// check later - https://stackoverflow.com/questions/71380626/swiperjs-v8-scss
// import "swiper/scss";
import "swiper/css/bundle";
import "swiper/css";
import SlidePrevButton from "./carousel-navigation-buttons/carousel-prev-button/carousel-prev-button";
import SlideNextButton from "./carousel-navigation-buttons/carousel-next-button/carousel-next-button";
import SubscriptionPlansStore, {
  PlanStore,
} from "../../stores/subscription-plans-store";
import {observer} from "mobx-react-lite";
import {useCallback, useEffect, useState} from "react";


interface IOfferedSubscriptionsPlansCarousel {
    showCarouselButtons: boolean,
    children: React.ReactNode,
}

const OfferedSubscriptionsPlansCarousel: React.FC<IOfferedSubscriptionsPlansCarousel> = observer((
    props
) => {

    const showCarouselButtons = props.showCarouselButtons;
    const [swiper, setSwiper] = useState<any>();
    const [isFirstSlide, setIsFirstSlide] = useState<boolean | undefined>(false);
    const [isLastSlide, setIsLastSlide] = useState<boolean | undefined>(false);

    const setNavigationVisibility = useCallback(() => {
        if (swiper) {
            setIsFirstSlide(() => {
                return swiper.activeIndex === 0;
            });
            setIsLastSlide(() => {
                return swiper.isEnd;
            });
        }

    }, [swiper]);

    useEffect(() => {
        if (typeof swiper !== 'undefined') {
            setNavigationVisibility();
        }
    }, [swiper, setNavigationVisibility]);

    return (
        <div className={`offered-plans-carousel`}>
            {
                showCarouselButtons && !isFirstSlide && (
                    <div className="slider-prev-button-wrapper">
                        <SlidePrevButton swiper={swiper}/>
                    </div>)
            }
            <div className="slider-wrapper" style={{maxWidth: `100%`}}>
                <Swiper
                    onUpdate={(swiper) => {
                        setSwiper(swiper);
                    }}
                    onReachEnd={() => {
                        setNavigationVisibility();
                    }}
                    onSlideChange={() => {
                        setNavigationVisibility();
                    }}
                    observer={true}
                    modules={[Pagination]}
                    pagination={{clickable: true}}
                    slidesPerView={"auto"}
                    spaceBetween={15}
                >
                    {props.children}
                </Swiper>
            </div>
            {
                showCarouselButtons && !isLastSlide && (
                    <div className="slider-next-button-wrapper">
                        <SlideNextButton swiper={swiper}/>
                    </div>
                )
            }
        </div>
    );
})

export default OfferedSubscriptionsPlansCarousel;
